module.exports = __webpack_public_path__ + "img/api-loading.9033f84.gif";